import React, { useContext } from 'react';
import styled from 'styled-components';
import { ConfirmationModal, Flex } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { ReactComponent as BaseWarningIcon } from '@ubeya/shared-web/assets/exclamation-mark-outlined.svg';

const Content = styled(Flex)`
  gap: 8px;
  align-items: flex-start;
  font-size: 14px;
  line-height: 20px;
`;

const WarningIcon = styled(BaseWarningIcon)`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  path {
    fill: ${({ theme }) => theme.colors.yellowPartially};
  }
`;

const LeaveEarningsLimitWarningModal = ({ onConfirm, onClose, loading = false, zIndex = 100 }) => {
  const { t } = useContext(ConfigContext);

  return (
    <ConfirmationModal
      isOpen
      usePortal
      showCancelButton
      onClose={onClose}
      onConfirm={onConfirm}
      loadingConfirm={loading}
      zIndex={zIndex}
      title={t('leaveEarningsLimitWarning_title')}
      confirmText="leaveEarningsLimitWarning_confirm"
      cancelText="cancel">
      <Content>
        <WarningIcon />
        {t('leaveEarningsLimitWarning_body')}
      </Content>
    </ConfirmationModal>
  );
};

export default React.memo(LeaveEarningsLimitWarningModal);
